import { render, staticRenderFns } from "./zh-CN.vue?vue&type=template&id=32c32259&"
import script from "./zh-CN.vue?vue&type=script&lang=js&"
export * from "./zh-CN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c32259')) {
      api.createRecord('32c32259', component.options)
    } else {
      api.reload('32c32259', component.options)
    }
    module.hot.accept("./zh-CN.vue?vue&type=template&id=32c32259&", function () {
      api.rerender('32c32259', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/zh-CN.vue"
export default component.exports